// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaTumblr_root__Z4l8B"};